// extracted by mini-css-extract-plugin
export var addButton = "_i2-0";
export var border = "_i2-8";
export var check = "_i2-h";
export var danger = "_i2-6";
export var dropdownContainer = "_i2-1";
export var editModalBody = "_i2-j";
export var footerContainer = "_i2-i";
export var fullWidth = "_i2-a";
export var hide = "_i2-9";
export var icon = "_i2-3";
export var input = "_i2-7";
export var inputFlex = "_i2-b";
export var inputWrapper = "_i2-c";
export var manualFocus = "_i2-5";
export var optionButton = "_i2-4";
export var pillWrapper = "_i2-e";
export var pointer = "_i2-2";
export var showOverflow = "_i2-f";
export var tagsFlex = "_i2-d";
export var xButton = "_i2-g";